/**
 * MatterCreationError - thrown when matter creation fails
 */
export class MatterCreationError extends Error {
  constructor(cause: unknown) {
    super('Failed to create matter')
    this.name = 'MatterCreationError'
    this.cause = cause
  }
}

/**
 * ConversationMatterAssignmentError - thrown when assigning a conversation to a matter fails
 */
export class ConversationMatterAssignmentError extends Error {
  constructor(cause: unknown) {
    super('Failed to assign conversation to matter')
    this.name = 'ConversationMatterAssignmentError'
    this.cause = cause
  }
}
